module.exports = __webpack_public_path__ + "static/media/abl.405ee463.webp";